
import { Component, Mixins } from 'vue-property-decorator';
import { ProgressbarMixin } from './ProgressbarMixin';

@Component
export default class ProgressBarDetail extends Mixins(ProgressbarMixin) {
  stepClass(step: number, enabled: boolean): string[] {
    return [
      'ds-progress-bar__step',
      ...(this.currentPageStep === step ? ['ds-progress-bar__step--active'] : []),
      ...(!enabled ? ['ds-progress-bar__step--disabled'] : []),
    ];
  }
}
